import {
    faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
    getAllLotteryBrandDay,
    getAllLotteryBrandDaysCode,
} from '../../../redux/features/lotteryBrandDay/lotteryBrandDayService';
import TableSkeleton from '../../../components/Skeleton';
import NoResultsFound from '../../../components/NoResultsFound';
import Modal from '../../../components/Modal';
import { showToast } from '../../../components/ToastMsg';
import { editLotteryInfo, getLotteries } from '../../../redux/features/lottery/lotteryService';
import Pagination from '../../../components/Pagination';

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const LotteryListing = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isLotteriesLoading, pageCount, lotteries } = useSelector((state) => state.lotteryTicket.lotteryTickets);

    const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);
    const [selectedLotteryId, setSelectedLotteryId] = useState(null);
    const [selectedLotteryName, setSelectedLotteryName] = useState('');
    const [reload, setReload] = useState(false);
    const [drawDate, setDrawDate] = useState(formatDate(new Date()));
    const [brand, setBrand] = useState(null);
    const [drawNo, setDrawNo] = useState(null);
    const [skip, setSkip] = useState(1);
    const limit = 25;

    const closeDeactivationModal = () => setDeactivationModalOpen(false);

    const fetchAllLotteries = useCallback(
        (filters = {}) => {
            const params = {
                draw_date: drawDate,
                draw_no: drawNo,
                lottery_brand_day_id: brand?.id,
                status: 1,
                skip: skip,
                limit: limit,
                ...filters,
            };
            dispatch(getLotteries(params));
        },
        [dispatch, drawDate, drawNo, brand, skip]
    );

    useEffect(() => {
        fetchAllLotteries();
    }, [fetchAllLotteries]);

    useEffect(() => {
        dispatch(getAllLotteryBrandDay({ status: true }));
    }, [dispatch, reload]);

    const handlePublish = async () => {
        setDeactivationModalOpen(false);
        try {
            const response = await dispatch(
                editLotteryInfo({ id: selectedLotteryId, is_published: true })
            ).unwrap();
            setSelectedLotteryId(null);
            showToast('success', response.message);
            fetchAllLotteries();
            setReload((prev) => !prev);
        } catch (error) {
            showToast('error', error.message);
        }
    };

    const handleEditLotteryDays = (lottery) => {
        navigate(`${lottery.lottery_brand_day.id}`, { state: { name: lottery.lottery_brand_day.name, draw_date: lottery.draw_date, draw_no: lottery.draw_no, count: lottery.count } });
    };

    useEffect(() => {
        dispatch(getAllLotteryBrandDaysCode({ id: brand }));
    }, [dispatch, brand, reload]);

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber);
    };

    return (
        <div className={`search-card`}>
            <div className={`search-card-header`}>
                <div className={`form-input-col`}>
                    <h1 className={`form-title ${styles.headDiv}`}>
                        Lottery Listing{' '}
                    </h1>
                </div>
                <div className={`form-input-col`}>
                    <div className={`form-input-group`}>
                        <input
                            type="date"
                            value={drawDate || ''}
                            onChange={(e) => setDrawDate(e.target.value)}
                            className={`form-input-default`}
                            placeholder="Draw Date"
                        />
                    </div>
                </div>
            </div>

            <div>
                {isLotteriesLoading ? (
                    <TableSkeleton
                        columns={['Image', 'Name', 'Draw Date', 'Draw No', 'Count', 'Status', 'Actions']}
                        rowCount={10}
                        height={20}
                    />
                ) : lotteries.length > 0 ? (
                    <div className={`table-container`}>
                        <table className={`table`}>
                            <thead className={`thead`}>
                                <tr>
                                    <th className={`theadColumnOne`}>Image</th>
                                    <th>Name</th>
                                    <th>Draw Date</th>
                                    <th>Draw No</th>
                                    <th>Count</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody className={`tbody`}>
                                {lotteries?.map((lottery) => (
                                    <tr key={lottery.id}>
                                        <td className={`tdataColumnOne`}> <img
                                            src={lottery?.lottery_brand_day.lottery_brand.logo_url}
                                            alt={`${lottery?.name} Logo`}
                                            className={styles.lotteryImage}
                                        /></td>
                                        <td style={{ minWidth: '200px' }}>{lottery?.lottery_brand_day.name}</td>
                                        <td className={styles.smTd}> {lottery?.draw_date} </td>
                                        <td className={styles.smTd}>{lottery?.draw_no}</td>
                                        <td className={styles.smTd}>{lottery?.count}</td>
                                        <td className={styles.smTd}>{lottery?.is_published ? 'Publish' : 'Draft'}</td>
                                        <td className={`actionsBtn ${styles.smBtnTd}`}>
                                            {!lottery?.is_published &&
                                                <button className={`btn-primary`} onClick={() => {
                                                    setSelectedLotteryId(lottery.id);
                                                    setSelectedLotteryName(lottery.lottery_brand_day.name);
                                                    setDeactivationModalOpen(true);
                                                }}
                                                    style={{ backgroundColor: 'var(--green)', borderColor: 'var(--green)' }}>
                                                    Publish
                                                </button>
                                            }
                                            <button
                                                className={`btn-primary`}
                                                onClick={() => handleEditLotteryDays(lottery)}
                                            >
                                                View
                                            </button>
                                            {lottery.lottery_results?.length === 0 &&
                                                <Link to={`/admin/listing/${lottery?.lottery_brand_day.lottery_brand.code}/${lottery.id}`}>
                                                    <button className="btn-primary">
                                                        Add Results
                                                    </button>
                                                </Link>
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <NoResultsFound />
                )}
                <div className={`search-card-footer`} style={{ marginTop: '20px' }}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>

            {isDeactivationModalOpen && (
                <Modal
                    title='Publish Lotteries'
                    onClose={closeDeactivationModal}
                    onYes={handlePublish}
                    isInput={false}
                    iconName={faCircleCheck}
                    bodyText={
                        <>
                            Are you sure you want to publish the lotteries?
                            <br />
                            <b>{selectedLotteryName}</b>
                        </>
                    }
                    colorType={`var(--green)`}
                />
            )}
        </div>
    );
};

export default LotteryListing;
